import { isValid } from 'date-fns'

/** Date-fns `format` throws on Invalid Date; skip empty, missing, and unparseable values. */
export function parseLastLogin(value: string | Date | null | undefined): Date | null {
  if (value == null || value === '') return null
  const parsed = value instanceof Date ? value : new Date(value)
  return isValid(parsed) ? parsed : null
}
